import React, { useState } from 'react';
import { sessionService } from 'redux-react-session';
import CryptoJS, { AES } from 'crypto-js';
import SecretKey from '../secret/SecretKey';

/**
 * 取得登入資訊
 * @param {any} data 登入資訊
 * 沒有登入的時候是null
 */
const SignInSession = {


    get: function (call) {

      
            sessionService.loadSession()
                .then(currentSession => {

                    try {
                        var _SecretKey = SecretKey.Key;
                        var data = AES.decrypt(currentSession, _SecretKey, {
                            mode: CryptoJS.mode.ECB,
                            padding: CryptoJS.pad.Pkcs7
                        }).toString(CryptoJS.enc.Utf8);
                        var models = JSON.parse(data);
                        call(models);
                    } catch (ex) {
                        call(null);
                    }
                })
                .catch(err => {
                    call(null);
                });

       
    },
    /**
     * 取得未解密的
     * @param {any} call
     */
    get_Secret: function (call) {

        sessionService.loadSession()
            .then(currentSession => {

                try {
                  
                    call(currentSession);
                } catch (ex) {
                    call(null);
                }
            })
            .catch(err => {
                call(null);
            });
    }
}

export default SignInSession;